import React from "react";
import List from "components/list";
import CreateListItemButton from "@/components/list/create-button";
import { StatusCell } from "@/components/status/cell";
import { DateCell } from "@/components/date/cell";

import { useNavigate } from "react-router-dom";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
} from "ui/components/dropdown-menu";
import RawEditItemButton from "components/buttons/raw-edit";

import { PermissionControlledInput } from "permissions/components/input";
import DropdownMenuButton from "components/dropdown-menu/button";
import { usePermissionRules } from "permissions/hooks/usePermissionRules";
import Loader from "@/components/loader";

export default function Performance() {
  const { data: permissions } = usePermissionRules(
    ["update:*"],
    "performance_review_months",
  );
  const { data: createQuadrant, isLoading } = usePermissionRules(
    ["create:*"],
    "performance_review_months",
  );

  const canEdit = permissions?.update || false;
  const fields = ["id", "name", "start_date", "end_date", "status"];

  const today = new Date();
  const twentyFiveDaysFromNow = new Date();
  twentyFiveDaysFromNow.setDate(today.getDate() + 25);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  if (isLoading) {
    return <Loader />;
  }

  const filters = {
    _or: [
      { status: { _eq: "completed" } },
      ...[
        createQuadrant?.create
          ? {}
          : {
            _and: [
              { status: { _eq: "ongoing" } },
              { end_date: { _gte: formatDate(today) } },
              { end_date: { _lte: formatDate(twentyFiveDaysFromNow) } },
            ],
          },
      ],
    ],
  };

  const baseColumns = [
    {
      header: "Name",
      accessorKey: "name",
    },
    {
      header: "Start Date",
      accessorKey: "start_date",
      cell: DateCell,
    },
    {
      header: "End Date",
      accessorKey: "end_date",
      cell: DateCell,
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
  ];

  const actionsColumn = {
    header: "",
    accessorKey: "actions",
    cell: ({ row }) => {
      const { id, status } = row.original;
      return (
        <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition">
          <DropdownMenu>
            <DropdownMenuButton />
            <DropdownMenuContent align="end">
              <PermissionControlledInput
                rule="update:*"
                collection="performance_review_months"
              >
                <DropdownMenuItem>
                  <RawEditItemButton href={`${id}/edit`} />
                </DropdownMenuItem>
              </PermissionControlledInput>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      );
    },
    sortable: false,
  };

  const columns = canEdit ? [...baseColumns, actionsColumn] : baseColumns;

  return (
    <div className="flex-1">
      <CreateListItemButton
        rule="create:*"
        collection="performance_review_months"
      >
        Create
      </CreateListItemButton>
      <List
        title="Performance Reviews"
        storageKey="performance_reviews"
        endPoint="performance_review_months"
        sortBy={"start_date"}
        filters={filters}
        // hidePagination={true}
        meta={{ fields }}
        showSearch={false}
        rowClassName="h-13"
        columns={columns}
        href={(item) => `/performance/review/${item.id}`}
      />
    </div>
  );
}
